import { extendObservable } from 'mobx';
// import config from 'config';
// import camelcaseKeys from 'camelcase-keys';
// import snakecaseKeys from 'snakecase-keys';
import http from '../utils/http';
import format from "date-fns/format"

let today = new Date();

let newDate = new Date();
newDate.setFullYear(newDate.getFullYear() - 1);

export class SearchStore {
  constructor() {
    extendObservable(this, {
      loading: false,
      categorySelect: [],
      mediaList: [],
      textSearch: '',
      startDate: newDate,
      endDate : today,
      pagination: {
        count: 0,
        limit: 30,
        offset: 0,
        page: 1,
        total_pages: 1
      }
    });
  }

  changeCategorySelect(data) {
    this.categorySelect = data;
  }
  changeField(task,data) {
    this[task] = data;
  }
  changePaginationOffset(value) {
    this.pagination.offset = value;
  }

  async submitSearch(task) {
    this.loading = true
    try {
      let categories = JSON.stringify(this.categorySelect);
      categories = categories.replace('[', '');
      categories = categories.replace(']', '');
      categories = categories === '' ? null : categories;
      let word = this.textSearch === '' ? null : this.textSearch;
      let start = this.startDate ? format(this.startDate, "yyyy-MM-dd") : null;
      let end = this.endDate ? format(this.endDate, "yyyy-MM-dd") : null;

      const query = {
        categories,
        word,
        start,
        end,
        offset: task === 'reload' ? this.pagination.offset : 0
      }
      const response = await http.get('/media/search', query);
      if (response) {
        this.pagination = response.pagination;
        this.mediaList = response.data
        return response;
      }

    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

}

const searchStore = new SearchStore();
export default searchStore;
